module.exports = __webpack_public_path__ + "img/1869-Alois-Karlon-erster-Direktor-Pressvereinsanstalt.9066542e.jpg";